import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';

export const dealershipItemDataProvider = WrappedComponent =>
  connectToModel(WrappedComponent, {
    selectedFilters: bindToPath(PersonalizedSearchPaths.getSelectedFilters(), PersonalizedSearchModel, null, false),
  });
